<template>
  <div v-if="onlyValue" :class="{'show-txt-rest':readonly,'blur-border': isFoucs,'visible-onlyValue': currentValue && currentValue.length > 0}" class="table-select-box input-day" @click="getBlur">
    <div style="width: 100%">
      <div class="table-select-onlyValue" v-if="currentValue && currentValue.length > 0">
        <toolTip :maxWidth="'100%'" :title="currentValue">
          <span>{{currentValue || '-'}}</span>
        </toolTip>
      </div>
      <p v-else class="table-select-button">
        <span v-if="readonly">暂无</span>
        <span v-else><i class="el-icon-circle-plus"></i>添加</span>
      </p>
    </div>
    <el-date-picker popper-class="only-value-date" ref="inputLongText" @blur="setBlurFoucs()" v-model="currentValue" @change="changeVal" clearable type="date" :placeholder="config.component_desc_in_template" value-format="dd" size="mini">
    </el-date-picker>
  </div>
  <div v-else-if="currentValue || !readonly">
    <div class="input-day">
      <div :class="{'show-txt-rest':readonly}" v-if="!isFoucs" @click="getBlur">
        <div class="only-value show-txt" v-if="currentValue && currentValue.length > 0">
          <span class="only-value">{{currentValue}}</span>
        </div>
        <span v-else class="add-txt">设置日期</span>
      </div>
      <el-date-picker v-else ref="inputLongText" @blur="setBlurFoucs()" v-model="currentValue" @change="changeVal" clearable type="date" :placeholder="config.component_desc_in_template" value-format="dd" size="mini">
      </el-date-picker>
    </div>
  </div>
</template>

<script>
export default {
  props: ['config', 'value', 'defaultValue', 'onlyValue', 'item', 'getketText', 'readonly', 'isTemplate'],
  data() {
    return {
      date: '',
      isFoucs: false,
      dataset: ''
    }
  },
  computed: {
    currentValue: {
      get: function () {
        return this.value || undefined;
      },
      set: function (newValue) {
        this.$emit('input', newValue || null)
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      if(this.isTemplate) {
        this.$emit("input", this.defaultValue)
      } else if (this.defaultValue && this.defaultValue.length > 0) {
        let val = this.getDefaultValue(this.defaultValue)
        this.$emit('input', val)
        this.dataset = val
      }
    },
    getMessage(res) {
      return `<span class="message-mixin-tip">将${res.field_name}修改为</span><span class="message-mixin-task">${res.new_data || `<span class="message-mixin-tip">无</span>`}</span>`
    },
    getDefaultValue(val) {
      if (val && val.length > 0) {
        return val[0].component_value
      }
    },
    changeVal(val, lr) {
      if (val !== null) {
        this.$emit('change', val, lr)
      }
    },
    getBlur() {
      if (this.readonly) return
      this.isFoucs = true
      this.$nextTick(() => {
        this.$refs.inputLongText.handleFocus()
      })
    },
    setBlurFoucs() {
      this.isFoucs = false
    }
  }
}
</script>

<style lang="scss">
.input-day {
  display: flex;
  align-items: center;
  max-width: 100%;
  .el-date-editor.el-input {
    width: 100%;
  }
}
</style>
